// File: frontend/src/pages/Unauthorized.jsx

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Unauthorized = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  // Function to navigate back to login asynchronously
  const handleBackToLogin = async () => {
    try {
      navigate('/login');
    } catch (error) {
      console.error('Error navigating to login:', error);
    }
  };

  // Function to navigate back to role dashboard asynchronously
  const handleGoToDashboard = async () => {
    try {
      if (!user) {
        navigate('/login');
        return;
      }
      const userRole = user?.role?.toLowerCase();
      switch (userRole) {
        case 'super_admin':
        case 'admin':
        case 'principal':
          navigate('/dashboard/admin');
          break;
        case 'teacher':
          navigate('/dashboard/teacher');
          break;
        case 'student':
          navigate('/dashboard/student');
          break;
        case 'parent':
          navigate('/dashboard/parent');
          break;
        default:
          navigate('/login');
          break;
      }
    } catch (error) {
      console.error('Error navigating to dashboard:', error);
      navigate('/login');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-100 px-4 py-12">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-xl border border-slate-200 p-8 text-center">
        
        {/* Error Icon */}
        <div className="mx-auto w-16 h-16 bg-red-100 text-red-600 rounded-full flex items-center justify-center mb-6">
          <svg
            className="w-8 h-8"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
            />
          </svg>
        </div>

        <h1 className="text-2xl font-extrabold text-slate-800 mb-2">Access Denied</h1>
        <p className="text-slate-500 text-sm mb-6 leading-relaxed">
          You do not have the required permissions to view this page. If you believe this is an error, please contact your school administrator.
        </p>

        <div className="flex flex-col sm:flex-row gap-3">
          <button
            onClick={handleGoToDashboard}
            className="flex-1 bg-primary hover:bg-blue-600 text-white font-medium py-2.5 rounded-xl transition duration-200 shadow-md text-sm"
          >
            My Dashboard
          </button>
          <button
            onClick={handleBackToLogin}
            className="flex-1 bg-slate-100 hover:bg-slate-200 text-slate-700 font-medium py-2.5 rounded-xl transition duration-200 border border-slate-300 text-sm"
          >
            Back to Login
          </button>
        </div>

      </div>
    </div>
  );
};

export default Unauthorized;
